import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\InquiryDemandController::__invoke
* @see app/Http/Controllers/InquiryDemandController.php:14
* @route '/kontakt'
*/
const InquiryDemandController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InquiryDemandController.url(options),
    method: 'post',
})

InquiryDemandController.definition = {
    methods: ["post"],
    url: '/kontakt',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InquiryDemandController::__invoke
* @see app/Http/Controllers/InquiryDemandController.php:14
* @route '/kontakt'
*/
InquiryDemandController.url = (options?: RouteQueryOptions) => {
    return InquiryDemandController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InquiryDemandController::__invoke
* @see app/Http/Controllers/InquiryDemandController.php:14
* @route '/kontakt'
*/
InquiryDemandController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InquiryDemandController.url(options),
    method: 'post',
})

export default InquiryDemandController